/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum METADATA {
	ON_COPY_DATA = "ON_COPY_DATA_METADATA",
	ON_PASTE_DATA = "ON_PASTE_DATA_METADATA"
}
